export default __webpack_public_path__ + "static/media/calendar.9eb2440f.svg";